import styles from "./ReadMoreBannerBottom.module.scss";

import { ESIInclude } from "@/components/__shared__/ESIInclude/ESIInclude";
import { useRouteParams } from "@/hooks/useRouteParams";
import { StandardProps } from "@/types/types";

export function ReadMoreBannerBottom({
  productListingData,
}: Pick<StandardProps, "productListingData">) {
  const bannerId = productListingData.banners?.readmoreBottomBannerId;

  const { query } = useRouteParams();

  if (!bannerId || (query.page && query.page !== "1")) {
    return null;
  }

  return (
    <aside
      aria-label="Banner"
      data-testid="read-more-banner-bottom-container"
      className={styles.readmorebannerbottom}
    >
      <ESIInclude
        src={`/content-renderer/${bannerId}?no-failure=true&includeCoreCss=false&includeCoreJS=false&includePolyfills=false`}
        id="read-more-banner-bottom"
      />
    </aside>
  );
}
